import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import Homepage from './Pages/Homepage/homepage.component';
import { Footer } from './Components/Footer/footer.component';
import DetailPage from './Pages/Detail/detail-page.component';
import ScrollIntoView from './Components/ScrollIntoView/scrollintoview.component';

import './App.scss';

class App extends Component {
  render() {
    return (
      <div className="App">
        <ScrollIntoView>
            <Route exact path="/tourism-community-stories" component={Homepage} />
            <Route path="/tourism-community-stories/:pageId" render={props => <DetailPage key={props.location.key} />} />
        </ScrollIntoView>
        <Footer />
      </div>
    )
  }
}

export default App;
